
import { ref, defineComponent, PropType, watch } from "vue";
import { Show } from "../types";

export default defineComponent({
  props: {
    index: {
      type: Number,
      required: true,
    },
    show: {
      type: Object as PropType<Show>,
      required: true,
    },
  },
  emits: ["select-show", "deselect-show"],
  setup(props, { emit }) {
    const selected = ref(false);

    watch(selected, (selected) => {
      if (selected) {
        emit("select-show", [props.index, props.show]);
        return;
      }
      emit("deselect-show", [props.index, props.show]);
    });

    return { selected };
  },
});
